import axios from "axios";
import imageCompression from "browser-image-compression";
import { useGlobalContext } from "../../GlobalContext";
import { toast } from "sonner";

const KYC_UPLOAD_URL = "https://bumppy.in/packky/api/v1/uploadKycImage.php";

export default function useKYCImageUpload() {
  const { baseurl, AdminId, authHeaders } = useGlobalContext();

  const compressImageMax = async (file) => {
    const options = {
      maxSizeMB: 0.1,
      maxWidthOrHeight: 600,
      useWebWorker: true,
      fileType: "image/jpeg",
      quality: 0.7,
    };

    const compressedFile = await imageCompression(file, options);

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = String(reader.result || "");

        const base64 = result.replace(
          /^data:image\/(jpeg|png|webp|jpg);base64,/,
          ""
        );

        resolve(base64);
      };

      reader.onerror = reject;
      reader.readAsDataURL(compressedFile);
    });
  };

  const uploadImageToServer = async (file, userId, type, itemName) => {
    if (!file) return "";
    if (typeof file === "string") return file;

    if (!userId) {
      toast.error("User ID is required for image upload");
      return "";
    }

    if (!type) {
      toast.error("Image type is required");
      return "";
    }

    if (file.size > 5 * 1024 * 1024) {
      throw new Error("Image too large (max 5MB)");
    }

    try {
      const base64 = await compressImageMax(file);

      const payload = {
        userid: String(userId),
        item_name: itemName || `${userId}_${type}`,
        image_data: base64,
        type,
        adminId: AdminId,
      };

      const res = await axios.post(KYC_UPLOAD_URL, payload, {
        headers: {
          ...authHeaders,
          "Content-Type": "application/json",
        },
      });

      if (String(res.data?.status) === "0") {
        return (
          res.data?.image_url || `${baseurl}/uploads/kyc/${userId}_${type}.jpg`
        );
      }

      throw new Error(res.data?.msg || "Upload failed");
    } catch (err) {
      console.error("uploadImageToServer error:", err);
      toast.error(err?.message || "Image upload failed");
      throw err;
    }
  };

  return {
    compressImageMax,
    uploadImageToServer,
  };
}